import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/author/List.vue');
const edit = () => import('@/views/author/Edit.vue');
const create = () => import('@/views/author/Create.vue');
const newPromotion = () => import('@/views/author/NewPromotion.vue');

export const authorRoute = [
  {
    path: '/news/author',
    name: 'new-author-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.AUTHOR_READ] },
  },
  {
    path: '/news/author/create',
    name: 'new-author-create',
    component: create,
    meta: { requiresAuth: false, permissions: [PERMISSION.AUTHOR_CREATE] },
  },

  {
    path: '/news/author/:id/edit',
    name: 'new-author-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.AUTHOR_UPDATE] },
  },

  {
    path: '/news/promotion',
    name: 'news-promotion',
    component: newPromotion,
    meta: { requiresAuth: false, permissions: [PERMISSION.NEW_PROMOTION_READ] },
  },
];
